import { createContext } from "react";
import initialState from "./initialState";
const appContext = createContext(initialState);

export default appContext;
